import { FC, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import queryString from 'query-string';
import { getConnectRequest } from 'redux/reducers/auth/reducer';
import { getIsAuth } from 'redux/reducers/auth/selectors';
import { EASSpinner } from 'components/EASSpinner';
import { REDIRECT_URL } from 'services/constants/env';

export const AuthCode: FC = () => {
	const { search } = useLocation();
	const navigateParams = queryString.parse(search);
	const code = navigateParams.code ? String(navigateParams.code) : null;
	const isAuth = useSelector(getIsAuth);
	// OAuth-код одноразовый: повторная отправка того же кода приводит к 401 и циклу логина
	const sentCodeRef = useRef<string | null>(null);

	const navigate = useNavigate();

	const dispatch = useDispatch();

	useEffect(() => {
		// console.log('------AuthCode------');
		// console.log('redirect_uri', REDIRECT_URL);
		// console.log('code', code);
		// console.log(isAuth);
		if (REDIRECT_URL && code && !isAuth && sentCodeRef.current !== code) {
			sentCodeRef.current = code;
			dispatch(
				getConnectRequest({
					code,
					grant_type: 'authorization_code',
					redirect_uri: REDIRECT_URL,
				}),
			);
		}
	}, [dispatch, code, isAuth]);

	useEffect(() => {
		if (isAuth) navigate(`/`);
		// if (isAuth) navigate(`${String(savedUrl ?? PATHS.HOME_PAGE)}`);
	}, [isAuth, navigate]);

	return <EASSpinner />;
};
